
import Vue from 'vue';

import Router from 'vue-router';

import p404 from './views/404';

import Home from "./views/Home";

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '',
            name: '404',
            component: p404,
        },
        {
            path: '/:slug',
            name: 'home',
            props: true,
            component: Home,
        },
    ]
})
